var treeBind = { item: '=' };
var TreeController = (function () {
    function TreeController(topic) {
        this.topic = topic;
        this.visible = true;
    }
    TreeController.prototype.getChildren = function () {
        switch (this.item.type) {
            case 'calculation': {
                return this.item.drpgs;
            }
            case 'drpg': {
                return this.item.partNumbers;
            }
            case 'partNumber': {
                return this.item.lineItems;
            }
        }
    };
    TreeController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    TreeController.prototype.getErrors = function () {
        return this.item.errors && this.item.errors.errorList.join('\n');
    };
    TreeController.prototype.isError = function () {
        return this.item.errors && this.item.errors.errorList.length > 0;
    };
    TreeController.$inject = ['topic'];
    return TreeController;
}());
angular
    .module('application')
    .component('treePayment', new TreeComponent());

//# sourceMappingURL=treeController.js.map
